export default {
    generations:[],
    events:[],
    imgs:[],
    open:false,
    slidePhoto:'',
    loadSpinner:false,

  }